export const CATEGORY_GAME_START_COMPLETED = "categoryGame/startCompleted";
export const CATEGORY_GAME_SUBMIT_COMPLETED = "categoryGame/submitCompleted";
export const CATEGORY_GAME_STATUS_COMPLETED = "categoryGame/statusCompleted";
